class LoadingService {
  constructor() {
    this._loader = null;
  }

  init(ref) {
    if (this._loader) {
      return;
    }
    this._loader = ref;
  }

  destroy() {
    this._loader = null;
  }

  showLoader() {
    this._loader.showLoader();
  }
  hideLoader() {
    this._loader.hideLoader();
  }

  showSuccessLoader() {
    this._loader.showSuccessLoader();
  }

  hideSuccessLoader({ callback = null, isSuccess = true } = {}) {
    this._loader.hideSuccessLoader({ callback, isSuccess });
  }
}

const loadingService = new LoadingService();

export default loadingService;
